(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craftsmanship-story"] && !Shopify.designMode) return;
  try {
    
  const initializeCraftStory = (root) => {
    if (!root || root.dataset.craftStoryInitialized === 'true') return;

    const video = root.querySelector('[data-craft-video] video');
    const toggle = root.querySelector('[data-craft-video-toggle]');
    const playIcon = root.querySelector('[data-craft-play-icon]');
    const pauseIcon = root.querySelector('[data-craft-pause-icon]');

    if (!video || !toggle || !playIcon || !pauseIcon) return;

    root.dataset.craftStoryInitialized = 'true';

    const playLabel = toggle.dataset.playLabel;
    const pauseLabel = toggle.dataset.pauseLabel;

    const syncButton = () => {
      const isPaused = video.paused;
      playIcon.hidden = !isPaused;
      pauseIcon.hidden = isPaused;
      toggle.setAttribute('aria-label', isPaused ? playLabel : pauseLabel);
    };

    toggle.addEventListener('click', () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', syncButton);
    video.addEventListener('pause', syncButton);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
    }

    syncButton();
  };

  document.querySelectorAll('[data-craft-story]').forEach(initializeCraftStory);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-craft-story]').forEach(initializeCraftStory);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-your-element"] && !Shopify.designMode) return;
  try {
    
  const initializeFindElement = (root) => {
    if (!root || root.dataset.findElementInitialized === 'true') return;

    const form = root.querySelector('[data-element-form]');
    const dateInput = root.querySelector('[data-element-date]');
    const result = root.querySelector('[data-element-result]');
    const cards = Array.from(root.querySelectorAll('[data-element-card]'));

    if (!form || !dateInput || !result || cards.length === 0) return;

    root.dataset.findElementInitialized = 'true';

    dateInput.addEventListener('input', () => {
      dateInput.setCustomValidity('');
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!form.reportValidity()) return;

      const dateParts = dateInput.value
        .trim()
        .split(/[./-]/)
        .map((part) => Number(part.trim()));
      const month = dateParts[0];
      const day = dateParts[1];
      const year = dateParts[2];
      const birthDate = new Date(year, month - 1, day);
      const today = new Date();
      const isValidDate =
        dateParts.length === 3 &&
        Number.isInteger(month) &&
        Number.isInteger(day) &&
        Number.isInteger(year) &&
        year >= 1900 &&
        birthDate.getFullYear() === year &&
        birthDate.getMonth() === month - 1 &&
        birthDate.getDate() === day &&
        birthDate <= today;

      if (!isValidDate) {
        dateInput.setCustomValidity(dateInput.dataset.invalidMessage);
        dateInput.reportValidity();
        return;
      }

      const cycle = ['metal', 'metal', 'water', 'water', 'wood', 'wood', 'fire', 'fire', 'earth', 'earth'];
      const cycleIndex = ((year - 1900) % cycle.length + cycle.length) % cycle.length;
      const element = cycle[cycleIndex];

      cards.forEach((card) => {
        card.hidden = card.dataset.elementCard !== element;
      });

      result.hidden = false;
      result.focus({ preventScroll: true });
    });
  };

  document.querySelectorAll('[data-find-element]').forEach(initializeFindElement);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-find-element]').forEach(initializeFindElement);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meaningful-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const forms = document.querySelectorAll('[data-ov-gift-pair]');

  for (const form of forms) {
    if (form.dataset.enhanced === 'true') continue;
    form.dataset.enhanced = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-pair-status]');
      const currentPairInput = form.querySelector('[data-current-pair-variant]');
      const giftVariantInput = form.querySelector('[data-gift-variant]');
      const mainVariantInput =
        document.querySelector('product-information form[action*="/cart/add"] input[name="id"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]');
      const currentVariantId = mainVariantInput?.value || form.dataset.currentVariantId;
      const giftVariantId = giftVariantInput?.value;

      if (!currentVariantId || !giftVariantId || !button || !currentPairInput) return;

      currentPairInput.value = currentVariantId;
      button.disabled = true;
      button.textContent = form.dataset.addingText || button.textContent;
      if (status) status.textContent = '';

      try {
        const response = await fetch(form.dataset.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              { id: currentVariantId, quantity: 1 },
              { id: giftVariantId, quantity: 1 },
            ],
          }),
        });

        if (!response.ok) throw new Error('cart-add-failed');
        window.location.assign(form.dataset.cartUrl);
      } catch (error) {
        button.disabled = false;
        button.textContent = button.dataset.defaultText || button.textContent;
        if (status) status.textContent = form.dataset.errorText || '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('variant:update', (event) => {
    const section = event.target.closest('.shopify-section');
    const currentCard = section?.querySelector('[data-ov-shipping-progress]');
    const nextCard = event.detail?.data?.html?.querySelector('[data-ov-shipping-progress]');

    if (!currentCard || !nextCard) return;

    currentCard.replaceWith(nextCard.cloneNode(true));
  });

  } catch(e) { console.error(e); }
})();
})();
